import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { RadioButtonUnchecked, RadioButtonChecked }from '@material-ui/icons';
import { Radio, RadioGroup, FormControlLabel, Typography, TextField, InputAdornment, Button } from '@material-ui/core';

import style from '../../common/orders/ordersStyle.module.css';
import commonStyles from '../../common/common.module.css';

const TEXT_FIELD_PADDINGS: string = '8px 12px';

const styles = (theme: Theme) =>

  createStyles({
    radioGroup: {
      width: '175px',
      justifyContent: 'space-between'
    },
    label: {
      color: 'var(--primaryblue)',
      fontSize: '0.8125rem',
      zIndex: 0
    },
    labelText: {
      zIndex: 0
    },
    textField: {
      '& input' : {
        color: 'var(--primaryblue)',
        padding: TEXT_FIELD_PADDINGS,
        fontSize: '0.8125rem'
      },
      '& fieldset' : {
        borderRadius: '20px'
      }
    },
    button: {
      width: '110px',
    }
  });

interface NotifyTruckingCompanyProps {
  classes: any,
  email:string;
  phoneNumber: string;
  notifyBy: string;
  handleChange: Function;
  isPhoneNumber: boolean;
  prefixPhoneNumber: string;
  isEmail: boolean;
  onValidationEmail: (event: any) => void;
  onValidationPhoneNumber: (event: any) => void;
  notifyTrucker: any;
  notifyWho: string;
};

const notifyTruckingCompany = (props: NotifyTruckingCompanyProps) => {

  const phoneNumber: string = props.phoneNumber.replace('+1', '');
  const renderTextField = (): JSX.Element => {

    if (props.notifyBy === 'email') {

      return (
        // the html needs to be different otherwise the element is not fully rerendered and it looks broken because the length of labels is different
        <div className={ commonStyles.inputLabelWrapper }>
          <label className={ commonStyles.inputLabel }>Email</label>

          <TextField 
            id="email"
            value={ props.email }
            variant="outlined"
            fullWidth={ true }
            onChange={ props.handleChange('email') }
            onBlur={ props.onValidationEmail } 
            error={ !props.isEmail }
            helperText={ !props.isEmail ? 'The email is not valid!' : '' }
            className={ props.classes.textField }
            InputLabelProps={{
              className: props.classes.labelText,
              shrink: true
            }}
          />
        </div>
      );
    } else {

      return (
        <div className={ commonStyles.inputLabelWrapper }>
          <label className={ commonStyles.inputLabel }>Phone Number</label>
          <TextField 
            id="phoneNumber"
            value={ phoneNumber }
            variant="outlined"
            fullWidth={ true }
            onChange={ props.handleChange('phoneNumber') }
            onBlur={ props.onValidationPhoneNumber } 
            error={ !props.isPhoneNumber }
            helperText={ !props.isPhoneNumber ? 'The phone number is not valid!' : '' }
            InputLabelProps={{
              className: props.classes.labelText,
              shrink: true
            }}
            InputProps={{
              startAdornment: <InputAdornment position="start">{ props.prefixPhoneNumber }</InputAdornment>,
            }}
            className={ props.classes.textField }
          />
        </div>
      );
    }
  };

  return (
    <div className={ style.notifyTrcWrapper }>

      <div className={ style.flexTruck }>
      
        <div className={ style.notifyViaWrapper }>

          <div className={ style.pot }>Notify Via</div>
       
          <RadioGroup
            aria-label="notifyBy"
            name="notifyBy"
            value={ props.notifyBy }
            row={ true }
            onChange={ props.handleChange('notifyBy') }
            className={ props.classes.radioGroup }
          >
            <FormControlLabel 
              value="email" 
              control={
                < Radio 
                  icon={ <RadioButtonUnchecked color='primary' /> }
                  checkedIcon={ <RadioButtonChecked color='primary' /> }
                /> 
              } 
              label={<Typography className={ props.classes.label }> e-Mail</Typography>} 
            />

            <FormControlLabel 
              value="sms" 
              control={
                < Radio 
                  icon={ <RadioButtonUnchecked color='primary' /> }
                  checkedIcon={ <RadioButtonChecked color='primary' /> }
                /> 
              } 
              label={<Typography className={ props.classes.label }> SMS</Typography>} 
            />

          </RadioGroup>
          
        </div>

        <div className={ style.textField }>{ renderTextField() }</div>
        
      </div>
      <div>

        <Button 
          variant="contained" 
          color="primary" 
          className={ props.classes.button }
          disabled={ (props.notifyBy === 'email' && !props.email || props.notifyBy === 'sms' && !props.phoneNumber) } 
          onClick={ props.notifyTrucker }
        >
          Send
        </Button>
        
      </div>
      
    </div>
  );
};

export default withStyles(styles)(notifyTruckingCompany)